import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';

import CostTrackingAnalysisCard from './CostTrackingAnalysisCard';

export default function CostToDateAnalysisModal({
  visible,
  onCancel,
  cards,
  onCardClick,
}) {
  return (
    <Modal
      title="Cost to Date Analysis"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={1000}
      className="cost-tracking-analysis-fullscreen-modal"
      destroyOnClose
    >
      <div className="cost-tracking-analysis-fullscreen-modal-body">
        {cards.map((card) => (
          <CostTrackingAnalysisCard
            key={card.key}
            card={card}
            onClick={onCardClick}
          />
        ))}
      </div>
    </Modal>
  );
}

CostToDateAnalysisModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
    estimated: PropTypes.number,
    actual: PropTypes.number,
    hasEstimated: PropTypes.bool,
    estPct: PropTypes.number,
    actPct: PropTypes.number,
    difference: PropTypes.number,
    isFavorable: PropTypes.bool,
  })),
  onCardClick: PropTypes.func.isRequired,
};

CostToDateAnalysisModal.defaultProps = {
  cards: [],
};
